import store from "../../../store/index";
import { DRAG_DROP } from "../../../constants/actionTypes";
import { updateNameAssetWithoutCampaign } from "../../Campaigns/AssetsWithOutCampaigns/actions";
import { EMAIL_BROWSER_ADD_EMAIL } from "constants/actionTypes";
//TODO: action to fetch all the assets with it's versions
//TODO: action to create a new Asset without Campaign
//TODO: action to create a new Draft in a

export const startDragAction = (item: any) => {
  store.dispatch({
    type: DRAG_DROP.IS_DRAG,
    payload: { isDrag: true, item: item },
  });
};

export const stopDragAction = () => {
  store.dispatch({
    type: DRAG_DROP.IS_DRAG,
    payload: { isDrag: false, item: {} },
  });
};

export const setCheckArticles = (data: any) => {
  store.dispatch({
    type: DRAG_DROP.SET_CHECK_ARTICLES,
    payload: data,
  });
};

//* remove the selected items
export const removeSelectedIds = () => {
  store.dispatch({
    type: DRAG_DROP.REMOVE_SELECTED_ID,
  });
};

//* open the abandon popup
export const openAbandonPopup = () => {
  store.dispatch({
    type: DRAG_DROP.OPEN_ABANDON_POPUP,
  });
};

//* close the abandon popup
export const closeAbandonPopup = () => {
  store.dispatch({
    type: DRAG_DROP.CLOSE_ABANDON_POPUP,
  });
};

export const setHoveredAssetId = (id: string | number) => {
  store.dispatch({
    type: DRAG_DROP.SET_HOVERED_ASSET_ID,
    payload: id,
  });
};

export const gillRoyMoveUp = () => {
  store.dispatch({ type: DRAG_DROP.GILL_ROY_MOVE_UP });
};

export const gillRoyMoveDown = () => {
  store.dispatch({ type: DRAG_DROP.GILL_ROY_MOVE_DOWN });
};

export const updateDraftName = (assetName: string, assetId: string) => {
  store.dispatch({ type: EMAIL_BROWSER_ADD_EMAIL.SET_ASSET_NAME, payload: { assetName, assetId } });
  updateNameAssetWithoutCampaign(assetName, assetId);
};
